<template>
    <div class="flex justify-between bg-primary text-white whitespace-nowrap p-3  md:px-16 md:py-5">


        <div class="flex-grow-5 grid md:grid-cols-4 items-center gap-y-3  justify-between md:text-2xl "
            style="font-family: 'Courier New', Courier, monospace;">
            <router-link to="/">
                <h3 class="text-xl md:text-4xl font-bold">Sound Workshop</h3>
            </router-link>
            <div class="flex gap-x-6 justify-evenly w-full md:col-span-3">

                <router-link :to="comp.path" :key="comp.path" v-for="comp in comps">{{ comp.displayName }}</router-link>




            </div>


        </div>
        <Logo class="flex-shrink-1 " />
    </div>
</template>

<script setup lang="ts">
import Logo from './Logo.vue';


const comps = [
    // {displayName: 'Home', path: '/'},
    { displayName: 'Overtones', path: '/overtones' },
    { displayName: 'Play', path: '/play-sound' },
    { displayName: 'Wave', path: '/wave' },
]
</script>